import { createFileRoute } from '@tanstack/react-router'
import {
  FraudAnalysisModelDetailsPage,
  fraudScoreDatasetHealthQueryOptions,
  fraudScoreModelsQueryOptions,
  fraudScoreModelVersionQueryOptions,
  fraudScoreModelVersionsQueryOptions,
} from 'features/fraudAnalysis'
// TODO DASH-3033: Restore with the historyBucket prefetches below.
// import { ModelVersionHistoryBucket } from 'models'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/$modelVersionId'
)({
  component: FraudAnalysisModelDetailsPage,
  loader: ({
    context: { queryClient, buildRequest, fraudScoreEntitlement },
    params: { subscriptionId, labelSlug, clientType, modelVersionId },
  }) => {
    if (fraudScoreEntitlement === 'disabled') {
      return
    }

    void queryClient.prefetchInfiniteQuery(
      fraudScoreModelsQueryOptions(buildRequest, subscriptionId, { labelSlug, clientType })
    )
    void queryClient.prefetchInfiniteQuery(
      fraudScoreModelVersionsQueryOptions(buildRequest, subscriptionId, labelSlug, clientType)
    )
    // TODO DASH-3033: Replace the unfiltered prefetch above when Legendary Blade supports historyBucket.
    // void queryClient.prefetchInfiniteQuery(
    //   fraudScoreModelVersionsQueryOptions(buildRequest, subscriptionId, labelSlug, clientType, {
    //     historyBucket: ModelVersionHistoryBucket.Versions,
    //   })
    // )
    // void queryClient.prefetchInfiniteQuery(
    //   fraudScoreModelVersionsQueryOptions(buildRequest, subscriptionId, labelSlug, clientType, {
    //     historyBucket: ModelVersionHistoryBucket.Discarded,
    //   })
    // )
    void queryClient.prefetchQuery(fraudScoreModelVersionQueryOptions(buildRequest, subscriptionId, modelVersionId))
    void queryClient.prefetchQuery(
      fraudScoreDatasetHealthQueryOptions(buildRequest, subscriptionId, {
        labelSlug,
        clientType,
      })
    )
  },
})
